module.exports = __webpack_public_path__ + "bd2a4e92889c2997523607f85a843a56.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../images/speakers/small/armagan-amcalar.jpg
// module id = 656
// module chunks = 0